module.exports = __webpack_public_path__ + "fonts/fccf25a.ttf";